import Page from "./index";

export default Page;
